import React from "react";
import { Clock } from "lucide-react";

const DAY_LABELS = { mon: "Pondělí", tue: "Úterý", wed: "Středa", thu: "Čtvrtek", fri: "Pátek", sat: "Sobota", sun: "Neděle" };
const DAY_ORDER = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

/**
 * Per-weekday opening hours — feeds directly into the booking slot
 * generator (GET /bookings/available-slots/{date}), so changes here are
 * immediately reflected in the customer-facing calendar.
 */
export default function BusinessHoursEditor({ hours, onChange }) {
  const data = hours || {};
  const getDay = (d) => data[d] || { open: "08:00", close: "20:00", closed: false };
  const setDay = (d, patch) => onChange({ ...data, [d]: { ...getDay(d), ...patch } });

  return (
    <div className="rounded-2xl bg-apex-card border border-apex-line p-5" data-testid="section-business-hours">
      <div className="text-xs uppercase tracking-[0.3em] text-apex-gold/80 mb-1 flex items-center gap-2">
        <Clock className="w-3.5 h-3.5" /> Otevírací doba
      </div>
      <p className="text-xs text-apex-cream/60 mb-4">
        Nastavené hodiny se propíší přímo do rezervačního kalendáře — zákazníci uvidí jen volné termíny v tomto rozsahu.
      </p>
      <div className="space-y-2">
        {DAY_ORDER.map((d) => {
          const day = getDay(d);
          return (
            <div key={d} className="flex flex-wrap items-center gap-3 rounded-xl border border-apex-line bg-apex-bg/50 px-4 py-3">
              <div className="w-24 text-sm text-apex-cream font-medium flex-shrink-0">{DAY_LABELS[d]}</div>
              <label className="inline-flex items-center gap-1.5 text-xs text-apex-cream/70 flex-shrink-0">
                <input
                  type="checkbox"
                  checked={!!day.closed}
                  onChange={(e) => setDay(d, { closed: e.target.checked })}
                  data-testid={`hours-${d}-closed`}
                />
                Zavřeno
              </label>
              {!day.closed && (
                <div className="flex items-center gap-2">
                  <input
                    type="time"
                    step={1800}
                    value={day.open}
                    onChange={(e) => setDay(d, { open: e.target.value })}
                    className="px-2 py-1.5 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm focus:outline-none focus:border-apex-gold/60"
                    data-testid={`hours-${d}-open`}
                  />
                  <span className="text-apex-cream/50 text-sm">–</span>
                  <input
                    type="time"
                    step={1800}
                    value={day.close}
                    onChange={(e) => setDay(d, { close: e.target.value })}
                    className="px-2 py-1.5 rounded-lg bg-apex-bg border border-apex-line text-apex-cream text-sm focus:outline-none focus:border-apex-gold/60"
                    data-testid={`hours-${d}-close`}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
